import { INNKRYSSING_CONFIG } from "../config.js";
import axios from "axios";

export default {
  getWatercourses: function() {
    return axios.get(
      INNKRYSSING_CONFIG.API_URL + "/Watercourse/getAllWatercourses"
    );
  },

  getWatercourse: function(watercourseId) {
    return axios.get(
      INNKRYSSING_CONFIG.API_URL +
        "/Watercourse/getWatercourse/" +
        watercourseId
    );
  }
};
